import apiPurchaseOrderStockist from '../../../api/purchaseOrderStockist';

const defaultState = () => ({
	productWarehouse: [],
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: '',
	bv: 0,
	progressivePrice: [],
});

const state = defaultState();

const getters = {
	
};

const mutations = {
	setProductWarehouse(state, data) {
		state.productWarehouse = data
	},
	saveResponse(state, data) {
		state.response = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	setMinimumBV(state, data) {
		state.bv = data
	},
	setProgressivePrice(state, data) {
		state.progressivePrice = data
	},
};

const actions = {
	getProductWarehouse({ commit }, params){
		return new Promise((resolve, reject) => {
			apiPurchaseOrderStockist.getProductWarehouse(params).then(({ data: { data } }) => {
				commit('setProductWarehouse', data.results )
				resolve(data.results)
			}).catch(err => {
				commit('setProductWarehouse', [] )
				reject(err)
			})
		})
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
	async saveProductPOStockist({ commit, dispatch }, params) {
		await apiPurchaseOrderStockist.saveProductPOStockist(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)

			//console.log(data.code)

			if (data.code == 400) {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: data.message
				}, { root: true });
			} else {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Gagal menyimpan data'
				}, { root: true });
			}
		});
	},
	getMinimumBV({ commit }){
		return new Promise((resolve, reject) => {
			apiPurchaseOrderStockist.getMinimumBV().then(({ data: { data } }) => {
				commit('setMinimumBV', data.results.bv )
				resolve(data.results.bv)
			}).catch(err => {
				commit('setMinimumBV', 0)
				reject(err)
			})
		})
	},
	async saveMinimumBV({ commit, dispatch }, params) {
		await apiPurchaseOrderStockist.saveMinimumBV(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)

			//console.log(data.code)

			if (data.code == 400) {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: data.message
				}, { root: true });
			} else {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Gagal menyimpan data'
				}, { root: true });
			}
		});
	},
	getProgressivePrice({ commit }){
		return new Promise((resolve, reject) => {
			apiPurchaseOrderStockist.getProgressivePrice().then(({ data: { data } }) => {
				commit('setProgressivePrice', data.results.data )
				resolve(data.results.data)
			}).catch(err => {
				commit('setProgressivePrice', [])
				reject(err)
			})
		})
	},
	async saveProgressivePrice({ commit, dispatch }, params) {
		await apiPurchaseOrderStockist.saveProgressivePrice(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)

			//console.log(data.code)

			if (data.code == 400) {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: data.message
				}, { root: true });
			} else {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Gagal menyimpan data'
				}, { root: true });
			}
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};